module.exports = __webpack_public_path__ + "img/icon-heart.922179ca.svg";